import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "message-username"
}
const _hoisted_3 = { class: "message-text" }
const _hoisted_4 = { class: "message-timestamp" }

import { iChatMessageModel, iChatType } from '@/types/common/models'
import MessageAttachment from '@/components/chat/MessageAttachment.vue'
import store from '@/store'
import { computed } from 'vue'
import { dayjs } from 'element-plus'
import { setMessageSeen } from '@/store/actions/chat'

type iMessageType = 'in' | 'out'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageItem',
  props: {
    chatType: {},
    message: {}
  },
  emits: ['load'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const path = computed(() => `${props.chatType}/${props.message.chatId}`)

const created = dayjs(props.message.createdAt).format('DD.MM.YYYY HH:mm')

const messageType: iMessageType = props.message.userId === store.state.user?.id ? 'out' : 'in'

if (!props.message.isViewed) {
  // Отмечаем сообщение как прочитанное, если писали его не мы
  if (store.state.user && props.message.userId !== store.state.user.id) {
    setMessageSeen(props.chatType, props.message.chatId, props.message.id)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-message", ['message-' + _unref(messageType)]])
  }, [
    (props.message.attachments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (props.message.userId !== _unref(store).state.user?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.message.user.name), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.message.attachments, (attachment) => {
            return (_openBlock(), _createBlock(MessageAttachment, {
              key: attachment.filename,
              path: path.value,
              attachment: attachment,
              onLoad: _cache[0] || (_cache[0] = ($event: any) => (emit('load')))
            }, null, 8, ["path", "attachment"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.message.message), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(created)), 1)
  ], 2))
}
}

})